export default __webpack_public_path__ + "static/media/AutoJoinNormal.0e08bba1.svg";